import { render } from "./cAbout.vue?vue&type=template&id=31b6d4bb&scoped=true"
import script from "./cAbout.vue?vue&type=script&lang=js"
export * from "./cAbout.vue?vue&type=script&lang=js"

import "./cAbout.vue?vue&type=style&index=0&id=31b6d4bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b6d4bb"]])

export default __exports__